import React, { useState } from 'react';

import { Campagne } from '../../Campagne'
import { Questions } from '../../Questions'

import { Route, BrowserRouter, Routes } from "react-router-dom";

import { FormulaireProposition, FormulaireProjet } from '../../Formulaire'
import { End } from '../../../views/End'

export const AppContainer = (props) => {

    const [progressBar, setProgressBar] = useState(1);

    return (
        <>
            <div className="main-page">
                <div className="progress-bar-container">
                    <img src={require(`../../../assets/images/SVG/Progress-bar-${progressBar}.svg`)} alt=""></img>
                </div>
                <div className="box-content" tabIndex="-1">
                    <BrowserRouter>
                        <Routes>
                            {/* <Route exact path="/" component={Question1} />
                            <Route exact path="/question2" component={Question2} /> */}
                            <Route path="/" element={<Questions page={setProgressBar} />} />
                            <Route path="/campagne" element={<Campagne page={setProgressBar} />} />
                            <Route path="/question" element={<Questions page={setProgressBar} />} />
                            <Route path="/formulaire/projet" element={<FormulaireProjet page={setProgressBar} />} />
                            <Route path="/formulaire/proposition" element={<FormulaireProposition page={setProgressBar} />} />
                            <Route path="/merci" element={<End />} />
                            <Route path="*" element={<Questions page={setProgressBar} />} />
                        </Routes>
                    </BrowserRouter>
                </div>
            </div>
        </>
    )
}